import {useTheme} from "../../contexts/theme";
import {Box, Grid} from "@mui/material";
import StyledIconButton from "./CommonComponents/StyledIconButton/StyledIconButton";
import LoopIcon from "@mui/icons-material/Loop";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import SkipPrevious from "@mui/icons-material/SkipPrevious";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrow from "@mui/icons-material/PlayArrow";
import {formatDuration} from "./utils/utils";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import TransparentButton from "./CommonComponents/TransparentButton/TransparentButton";
import React from "react";


export default function ({onBlur,isWindowUpdating, onDone, muted, onMute, onPause, onPlay, isPlaying, onFocus, videoTime, onSkip, onRewind, onReset}) {

    const theme = useTheme();

    const iconStyle = {
        backgroundColor: 'transparent',
        fill: theme.palette.white,
    }

    return (
        <Grid
            container
            justifyContent="space-between"
            sx={{
                maxWidth: "100%",
            }}
        >
            <Grid item>
                <Box sx={{ display: "flex", gap: theme.spacing.sm }}>
                    <StyledIconButton onBlur={onBlur} onFocus={onFocus} onClick={() => !muted ? onMute(true) : onMute(false)}>
                        {!muted ?
                            <VolumeOffIcon sx={iconStyle} /> :
                            <VolumeUpIcon sx={iconStyle} />
                        }
                    </StyledIconButton>
                </Box>
            </Grid>

            <Grid item>
                <Box sx={{ display: "flex", gap: theme.spacing.sm}}>
                    <StyledIconButton onBlur={onBlur} onFocus={onFocus} onClick={onRewind ? () => onRewind(10) : () => {}} ><SkipPrevious sx={iconStyle} /></StyledIconButton>
                    <StyledIconButton onBlur={onBlur} onFocus={onFocus} onClick={isPlaying ? onPause : onPlay}>
                        {isPlaying ? <PauseIcon sx={iconStyle}/> : <PlayArrow sx={iconStyle}/>}
                        {formatDuration(videoTime, false, true)}
                    </StyledIconButton>
                    <StyledIconButton onBlur={onBlur} onFocus={onFocus} onClick={onSkip ? () => onSkip(10) : () => {}}><SkipNextIcon sx={iconStyle}/></StyledIconButton>
                </Box>
            </Grid>


            {
                <Grid
                item
                md={12}
                lg={"auto"}
                sx={{
                    paddingTop: {md: '10px', lg:'0'},
                    display: "flex",
                    justifyContent: { xs: "center", sm: "center", md: "center" },
                    gap: theme.spacing.sm,
                }}
            >

                    {//Da rispistinare nella 4.0 quando piattaforma avrà l'endpoint per scaricare clip temporanee
                        /*<TransparentButton disabled={isWindowUpdating} onClick={onDone} onBlur={onBlur} onFocus={onFocus} text='Download' width={'120px'}/>*/}
            </Grid>}
        </Grid>
    );
}